import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';
import { FC, memo } from 'react';
import { ConvenienceDispatchFixedRouteEntity } from 'src/entities/ConvenienceDispatchFixedRoute.entity';

type Props = {
  open: boolean;
  fixedRoutes: ConvenienceDispatchFixedRouteEntity[];
  isLoading: boolean;
  onSelect: (fixedRouteId: number) => void;
  onClose: () => void;
};

const FixedRouteSelectorDialog: FC<Props> = memo(
  ({ open, fixedRoutes, isLoading, onSelect, onClose }) => {
    const activeRoutes = fixedRoutes.filter((r) => r.status === 'active');

    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>固定コースを選択</DialogTitle>
        <DialogContent dividers>
          {isLoading && (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
              <CircularProgress />
            </Box>
          )}
          {!isLoading && activeRoutes.length === 0 && (
            <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
              有効な固定コースがありません
            </Typography>
          )}
          {!isLoading && activeRoutes.length > 0 && (
            <List disablePadding>
              {activeRoutes.map((route) => (
                <ListItemButton
                  key={route.id}
                  onClick={() => onSelect(route.id)}
                  divider
                >
                  <ListItemText
                    primary={route.name}
                    secondary={
                      route.description
                        ? `${route.description} / 車両数: ${route.vehicleCount}`
                        : `車両数: ${route.vehicleCount}`
                    }
                  />
                </ListItemButton>
              ))}
            </List>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>キャンセル</Button>
        </DialogActions>
      </Dialog>
    );
  }
);

export default FixedRouteSelectorDialog;
